import CartQuery from 'Query/Cart.query';
import {
    CartDispatcher as SourceCartDispatcher
} from 'SourceStore/Cart/Cart.dispatcher';
import { showNotification } from 'Store/Notification/Notification.action';
import { isSignedIn } from 'Util/Auth';
import { getCartId } from 'Util/Cart';
import { fetchMutation, getErrorMessage } from 'Util/Request';

/** @namespace Elganso/Store/Cart/Dispatcher */
export class CartDispatcher extends SourceCartDispatcher {
    async applyValeToCart(dispatch, couponCode) {
        try {
            const isCustomerSignedIn = isSignedIn();
            const cartId = getCartId();

            if (!isCustomerSignedIn && !cartId) {
                return false;
            }

            const { applyVale: { cartData = {} } = {} } = await fetchMutation(
                CartQuery.getApplyValeMutation(couponCode, cartId)
            );

            this._updateCartData(cartData, dispatch);
            dispatch(showNotification('success', __('Vale was applied!')));

            return true;
        } catch (error) {
            dispatch(showNotification('error', getErrorMessage(error)));

            return false;
        }
    }

    async applyTarjetaMonederoToCart(dispatch, tarjetaMonederoCode) {
        try {
            const isCustomerSignedIn = isSignedIn();
            const cartId = getCartId();

            if (!isCustomerSignedIn && !cartId) {
                return false;
            }

            const { applyTarjetaMonedero: { cartData = {} } = {} } = await fetchMutation(
                CartQuery.getApplyTarjetaMonederoMutation(tarjetaMonederoCode, cartId)
            );

            this._updateCartData(cartData, dispatch);
            dispatch(showNotification('success', __('Gift Card Code was applied!')));

            return true;
        } catch (error) {
            dispatch(showNotification('error', getErrorMessage(error)));

            return false;
        }
    }

    async addGiftToCart(dispatch, textA, textDe, textText) {
        try {
            const isCustomerSignedIn = isSignedIn();
            const cartId = getCartId();

            if (!isCustomerSignedIn && !cartId) {
                return false;
            }

            const { addGiftToQuote: { cartData = {} } = {} } = await fetchMutation(
                CartQuery.getAddGiftMutation(textA, textDe, textText, cartId)
            );

            this._updateCartData(cartData, dispatch);
            dispatch(showNotification('success', __('Gift was save!')));

            return true;
        } catch (error) {
            dispatch(showNotification('error', getErrorMessage(error)));

            return false;
        }
    }

    async updateGiftFromCart(dispatch, textA, textDe, textText) {
        try {
            const isCustomerSignedIn = isSignedIn();
            const cartId = getCartId();

            if (!isCustomerSignedIn && !cartId) {
                return false;
            }

            const { updateGiftQuote: { cartData = {} } = {} } = await fetchMutation(
                CartQuery.updateGiftFromCartMutation(textA, textDe, textText, cartId)
            );

            this._updateCartData(cartData, dispatch);
            dispatch(showNotification('success', __('Gift was save!')));

            return true;
        } catch (error) {
            dispatch(showNotification('error', getErrorMessage(error)));

            return false;
        }
    }

    async removeGiftFromCart(dispatch) {
        try {
            const isCustomerSignedIn = isSignedIn();
            const cartId = getCartId();

            if (!isCustomerSignedIn && !cartId) {
                return false;
            }

            const { removeGiftFromQuote: { cartData = {} } = {} } = await fetchMutation(
                CartQuery.removeGiftFromCartMutation(cartId)
            );

            this._updateCartData(cartData, dispatch);
            dispatch(showNotification('success', __('Gift was deleted!')));

            return true;
        } catch (error) {
            dispatch(showNotification('error', getErrorMessage(error)));

            return false;
        }
    }

    async applyPointsToCart(dispatch, values) {
        try {
            const isCustomerSignedIn = isSignedIn();
            const cartId = getCartId();

            if (!isCustomerSignedIn && !cartId) {
                return false;
            }

            const { applyPoints: { cartData = {} } = {} } = await fetchMutation(
                CartQuery.getApplyPointsMutation(values, cartId)
            );

            this._updateCartData(cartData, dispatch);
            dispatch(showNotification('success', __('Points was applied!')));

            return true;
        } catch (error) {
            dispatch(showNotification('error', getErrorMessage(error)));

            return false;
        }
    }

    // eslint-disable-next-line consistent-return
    async removeValeFromCart(dispatch) {
        try {
            const isCustomerSignedIn = isSignedIn();
            const cartId = getCartId();

            if (!isCustomerSignedIn && !cartId) {
                return false;
            }

            const { removeVale: { cartData = {} } = {} } = await fetchMutation(
                CartQuery.getRemoveValeMutation(cartId)
            );

            this._updateCartData(cartData, dispatch);
            dispatch(showNotification('success', __('Coupon was removed!')));
        } catch (error) {
            dispatch(showNotification('error', getErrorMessage(error)));
        }
    }

    // eslint-disable-next-line consistent-return
    async removeTarjetaMonederoFromCart(dispatch) {
        try {
            const isCustomerSignedIn = isSignedIn();
            const cartId = getCartId();

            if (!isCustomerSignedIn && !cartId) {
                return false;
            }

            const { removeTarjetaMonedero: { cartData = {} } = {} } = await fetchMutation(
                CartQuery.getRemoveTarjetaMonederoMutation(cartId)
            );

            this._updateCartData(cartData, dispatch);
            dispatch(showNotification('success', __('Gift Card was removed!')));
        } catch (error) {
            dispatch(showNotification('error', getErrorMessage(error)));
        }
    }
}

export default new CartDispatcher();
